import React, { Component } from 'react';

//styles
import './bottomSection.scss';

import '../../static/fonts/opensanshebrew/stylesheet.css'
import '../../static/fonts/NarkisBlockCondensed/style.css'
import { GA_Event } from '../Analytics/Analytics'

class BottomSection extends Component {
    render() {
        return (
            <div className="section3-container">
                <div className="image"></div>
                <div className="desc-container">
                    <div className="title">
                        למי קראת הומו?
                </div>
                    <div className="desc">הומופוביה ישראלית, מודל 2018: החוקים שהיו ובוטלו - ואלה שעדיין כאן. מובילי המאבק נותנים תמונת מצב על האפליה הישראלית של קהילת הלהט"ב
                    <button className="btn" onClick={
                            () => {
                                window.location.href = `#/article/5273073/37`;
                                GA_Event('Button_Clicked', 'קרא עוד');
                            }
                        }>קרא עוד</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default BottomSection;


// WEBPACK FOOTER //
// ./src/Components/BottomSection/BottomSection.js